// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"e8e1c17b","61":"b319eac0","101":"fe77c561","106":"8cc359e7","311":"8fe9305e","344":"819f9a2c","609":"02425d5d","842":"50408d64"}[chunkId] + ".chunk.js";
};